/**
 * Created by Teo on 11/09/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('leadCallsAggregatedPerParentHospitalizationType', {
                parent: 'leadCallsAggregated',
                url: '/perParentHospitalizationType',
                data: {
                    authorities: ['ROLE_SYSTEM', 'ROLE_REC_MANAGEMENT', 'ROLE_REC_ADMINISTRATOR', 'ROLE_ADMIN'],
                    pageTitle: 'sigmaCrmApp.patient.home.title'
                },
                templateUrl: 'app/displays/adminIndex/leadCallsAggregated/perParentHospitalizationType/leadCallsAggregatedPerParentHospitalizationType.html',
                controller: 'LeadCallsAggregatedPerParentHospitalizationTypeController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('hospitalization');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
